import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { HelpConfig } from "@config/help-config";
import { Observable } from "rxjs";
import { SituacaoCandidatoDetranModel } from "@models/gestao/situacao-candidato-detran.model";

@Injectable({
    providedIn: 'root',
})
export class SituacaoCandidatoDetranService {
    private _httpClient: HttpClient = this.injector.get(HttpClient);
    
    constructor(
        protected injector: Injector,
        private helpConfig: HelpConfig
    ) {}

    getSituationByCpf(cpf: string): Observable<SituacaoCandidatoDetranModel> {
        return this._httpClient.get<SituacaoCandidatoDetranModel>(`${this.helpConfig.MANAGEMENT_API}situacaocandidatodetran?cpf=${cpf}`);
    }
}
